module.exports = __webpack_public_path__ + "static/media/search.e34ccc75.svg";